<template>
  <v-form ref="form">
    <div>
      <v-row>
        <v-col cols="12" class="mb-8">
          <h3 class="font-weight-bold black--text mb-4">Áreas Cadastradas</h3>
          <v-data-table
            :headers="headerAgricola"
            :items="getArrayTable"
            no-data-text="Nenhuma área foi cadastrada"
            loading-text="Carregando Áreas..."
            :server-items-length="getArrayTable.length"
            class="area-table base__datatable"
            :footer-props="{
              'items-per-page-options': [25, 50, 100, 250, 500]
            }"
            :hide-default-footer="true"
            :item-class="affectRow"
          >
            <template v-slot:[`item.area`]="{ item }">
              {{
                getArrayTable.indexOf(item) != getArrayTable.length - 1
                  ? "Área " + (getArrayTable.indexOf(item) + 1)
                  : ""
              }}
            </template>
            <template v-slot:[`item.plantedArea`]="{ item }">
              {{ asNumberString(item.plantedArea) }}
            </template>
            <template v-slot:[`item.visible`]="{ item }">
              <v-row
                class="mt-1 mb-1 vrow"
                v-if="getArrayTable.indexOf(item) != getArrayTable.length - 1"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <BaseButton
                      ref="myDataTable"
                      color="secondary"
                      class="base-input-file__button mr-1 px-0"
                      @click="viewRow(item)"
                      v-on="on"
                    >
                      <v-icon size="14"> fa-regular fa-eye </v-icon>
                    </BaseButton>
                  </template>
                  <span>Visualizar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <BaseButton
                      color="secondary"
                      class="base-input-file__button mr-1 px-0"
                      @click="editRow(item)"
                      v-on="on"
                    >
                      <v-icon size="12"> fas fa-pencil-alt </v-icon>
                    </BaseButton>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <BaseButton
                      color="secondary"
                      class="base-input-file__button mr-1 px-0"
                      @click="deleteRow(item)"
                      v-on="on"
                    >
                      <v-icon size="12"> fas fa-trash-alt </v-icon>
                    </BaseButton>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <BaseButton
                      color="secondary"
                      class="base-input-file__button mr-1 px-0"
                      @click="duplicateRow(item)"
                      v-on="on"
                    >
                      <v-icon size="14"> fa-thin fa-copy </v-icon>
                    </BaseButton>
                  </template>
                  <span>Duplicar</span>
                </v-tooltip>
              </v-row>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <ModalDeleteLineTable v-model="showDeleteModal" @close="closeModal" />
      <v-divider class="pb-6" />
      <v-row>
        <v-col cols="12" md="3" class="mb-xs-5 mb-sm-5" v-if="!enableArea">
          <BaseButton
            class="secondary text-uppercase subtitle-2 font-weight-bold"
            style="width: 100%"
            @click="addNewArea()"
          >
            <v-icon class="pr-4 add-icon">fa-plus</v-icon>
            ADICIONAR NOVA ÁREA
          </BaseButton>
        </v-col>
      </v-row>
      <v-row class="pb-0" v-if="enableArea">
        <v-col class="pr-0 pr-sm-2">
          <h3 class="font-weight-bold black--text mb-4">Adicionar nova área</h3>
          <BaseFormInput
            id-element="nameInsuredQuotation"
            placeholder="Inserir"
            v-model="newAreaItem.nome"
            required
            :rules="[requiredInput]"
            label-text="Nome da Área"
            item-text="name"
            :disabled="this.readOnlyState"
          />
        </v-col>
      </v-row>
      <v-row class="pb-0" v-if="enableArea">
        <v-col class="pr-0 pr-sm-2">
          <BaseMoney
            id-element="AreaSizeRiskQuotation"
            placeholder="0,00"
            label-text="Área Plantada"
            v-model="newAreaItem.plantedArea"
            required
            :rules="[requiredInput]"
            :money="typeDecimal"
            :disabled="this.readOnlyState"
            :errorMessages="areaPlantadaErrorMessages"
            :v-on:change="validateAreaPlantada()"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseFormInput
            id-element="plantingDateRiskQuotation"
            placeholder="DD/MM/YYYY"
            required
            :rules="[requiredInput, dateTermValid]"
            label-text="Data do Plantio"
            v-model="newAreaItem.plantingDate"
            v-facade="maskDate"
            :disabled="this.readOnlyState"
          />
        </v-col>
      </v-row>
      <v-row class="pb-2" v-if="enableArea">
        <v-col class="pr-0 pr-sm-2">
          <BaseFormSelect
            id-element="plantingTechniquesRiskQuotation"
            placeholder="Inserir"
            label-text="Técnicas de Plantio"
            v-model="newAreaItem.plantingTechniques"
            :items="plantingTechniques"
            item-text="nome"
            item-value="id"
            :return-object="true"
            required
            :rules="[requiredInput]"
            :disabled="this.readOnlyState"
          />
        </v-col>
        <v-col class="pr-0 pr-sm-2">
          <BaseFormSelect
            id-element="soilTypeRiskQuotation"
            placeholder="Inserir"
            label-text="Tipos de Solo"
            v-model="newAreaItem.soilType"
            :items="listClassificacaoSolo"
            item-text="nome"
            item-value="id"
            :return-object="true"
            required
            :rules="[requiredInput]"
            :disabled="this.readOnlyState"
            :errorMessages="tiposSoloErrorMessages"
            :v-on:change="validateTiposSolo()"
          />
        </v-col>
      </v-row>
      <v-row class="pb-2" v-if="enableArea">
        <v-col>
          <p class="font-weight-bold black--text quotation-title mb-1">
            Avaliação do Risco
          </p>
          <v-divider class="mb-2" />
        </v-col>
      </v-row>
      <v-row class="pb-2" v-if="enableArea">
        <div class="d-flex mb-2 pr-sm-10">
          <p class="primary--text mb-0">A lavoura já está plantada?</p>
          <v-switch
            v-model="newAreaItem.alreadyPlanted"
            class="pa-0 ma-0 ml-5"
            color="secondary"
            inset
            hide-details
            dense
            :disabled="this.readOnlyState"
          />
          <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
            {{ alreadyPlantedText }}
          </p>
        </div>
      </v-row>
      <v-row class="pb-2" v-if="enableArea">
        <div class="d-flex mb-0 pr-sm-10">
          <p class="primary--text mb-0">
            Trata-se de cultivo de soja pós cana-de-açucar?
          </p>
          <v-switch
            v-model="newAreaItem.soyAfterSuggarCane"
            class="pa-0 ma-0 ml-5"
            color="secondary"
            inset
            hide-details
            dense
            :disabled="this.readOnlyState"
          />
          <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
            {{ soyAfterSuggarCaneText }}
          </p>
        </div>
      </v-row>
      <v-row class="pb-2" v-if="enableArea">
        <div class="d-flex mb-0 pr-sm-0">
          <v-col sm="3" class="pr-0 pr-sm-1">
            <BaseFormSelect
              id-element="yearsPlantingQuotation"
              placeholder=""
              v-model="newAreaItem.yearsPlanting"
              :items="numberYearsPlanting"
              item-text="nome"
              item-value="id"
              :return-object="true"
              required
              :rules="[requiredInput]"
              :disabled="this.readOnlyState"
            />
          </v-col>
          <p class="primary--text mt-3 mb-0">
            de plantio pós cerrado/pastagem/mata nativa
          </p>
        </div>
      </v-row>
      <v-divider class="pb-6" v-if="enableArea" />
      <v-row v-if="enableArea">
        <QuotationKMLFile
          ref="quotationKMLFile"
          :areaItem="this.newAreaItem"
          :expectedMinAreaSize="getExpectedMinAreaSize"
          :expectedMaxAreaSize="getExpectedMaxAreaSize"
          class="col col-lg-12"
          :disabled="this.readOnlyState"
        />
      </v-row>
      <v-row v-if="!readOnlyState && enableArea">
        <v-col cols="2" class="mr-2">
          <BaseButton
            v-html="'Limpar'"
            class="secondary--text button-border"
            width="100%"
            outlined
            @click="clear()"
          />
        </v-col>
        <v-col cols="2" class="ml-2">
          <BaseButton
            ref="formFocus"
            v-html="'Gravar Área'"
            class="white--text secondary"
            width="100%"
            @click="addRow()"
          />
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>
<script>
import { requiredInput, dateTermValid } from "@/utils/rules.js";
import { maskDate } from "@/utils/masks.js";
import { mapActions, mapState } from "vuex";
import BaseMoney from "../../../components/base/BaseMoney.vue";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import ModalDeleteLineTable from "../components_agro/ModalDeleteLineTable.vue";
import _ from "lodash";
import {
  asNumberString,
  formatExpirationDate,
  formatDDMMYYYYToIsoDate
} from "@/utils/formats.js";
import QuotationKMLFile from "../components_agro/QuotationKMLFile.vue";
const headerAgricola = [
  { text: "Área", value: "area", sortable: false },
  { text: "Nome", value: "nome", sortable: false },
  {
    text: "Área Plantada",
    value: "plantedArea",
    type: "number",
    sortable: false
  },
  { text: "Data do Plantio", value: "plantingDate", sortable: false },
  {
    text: "Técnica de Plantio",
    value: "plantingTechniques.nome",
    sortable: false
  },
  {
    text: "Tipo de Solo",
    value: "soilType.nome",
    sortable: false
  },
  { text: "Ações", value: "visible", sortable: false }
];

const money = {
  decimal: ",",
  thousands: ".",
  prefix: "",
  suffix: "",
  precision: 2,
  masked: false /* doesn't work with directive */
};

const plantingTechniques = [
  {
    id: "direto_irrigado",
    nome: "Plantio Direto Irrigado"
  },
  {
    id: "direto",
    nome: "Plantio Direto"
  },
  {
    id: "convencional_irrigado",
    nome: "Plantio Convencional Irrigado"
  },
  {
    id: "convencional",
    nome: "Plantio Convencional"
  }
];

const numberYearsPlanting = [
  {
    id: 1,
    nome: "1º ano"
  },
  {
    id: 2,
    nome: "2º ano"
  },
  {
    id: 3,
    nome: "3º ano"
  },
  {
    id: 4,
    nome: "4º ano ou mais"
  }
];

const defaultItemAgricola = {
  id: null,
  key: 0,
  nome: null,
  plantedArea: 0,
  plantingDate: null,
  plantingTechniques: null,
  soilType: null,
  claimCurrentHarvest: false,
  alreadyPlanted: false,
  yearsPlanting: null,
  soyAfterSuggarCane: false,
  coordenadas: [],
  visible: true,
  kmlFiles: []
};

export default {
  data: () => ({
    formValid: true,
    maskDate,
    asNumberString,
    formatExpirationDate,
    formatDDMMYYYYToIsoDate,
    requiredInput,
    dateTermValid,
    headerAgricola,
    plantingTechniques: plantingTechniques,
    numberYearsPlanting: numberYearsPlanting,
    typeDecimal: money,
    newAreaItem: null,
    editState: false,
    readOnlyState: false,
    nextId: 0,
    selectedRowToAffect: null,
    isAddingRow: false,
    areaPlantadaErrorMessages: [],
    tiposSoloErrorMessages: [],
    enableArea: false,
    showDeleteModal: false,
    shouldDeleteData: false,
    totalAreaSize: 0
  }),
  mixins: [LoadingRequest],
  props: {
    form: {
      type: Object
    },
    subProduct: {
      type: Object
    }
  },
  components: {
    BaseMoney,
    QuotationKMLFile,
    ModalDeleteLineTable
  },
  created() {
    this.initializeIdGenerator();
    this.fetchClassificationSoil();
    this.newAreaItem = _.cloneDeep(defaultItemAgricola);
    this.newAreaItem.key = this.generateId();
  },
  methods: {
    ...mapActions("quotation", ["requestListClassificacaoSolo"]),
    ...mapActions(["showAlertNotification"]),
    initializeIdGenerator() {
      for (let i = 0; i < this.form.agricola.items.length; i++) {
        let item = this.form.agricola.items[i];
        if (this.nextId < item.key) {
          this.nextId = item.key + 1;
        }
      }
    },
    focusDataTable() {
      setTimeout(() => {
        this.$refs.myDataTable.$el.focus();
      }, 200);
    },
    focusForm() {
      setTimeout(() => {
        document.getElementById('nameInsuredQuotation').focus();
      }, 200);
    },
    generateId() {
      this.nextId++;
      return this.nextId - 1;
    },
    addNewArea() {
      this.enableArea = true;
      this.editState = false;
      this.focusForm();
    },
    addRow() {
      this.newAreaItem.coordenadas = this.$refs.quotationKMLFile.getCoordinates();

      if (!this.validForm) {
        this.validateInputBaseMoney();
        this.showAlertNotification({
          message: "Preencha todos os campos corretamente antes de prosseguir.",
          type: "error"
        });
        return;
      }

      if (!this.editState) {
        this.newAreaItem.key = this.generateId();
        this.form.agricola.items.push(_.cloneDeep(this.newAreaItem));
      } else {
        let index = this.form.agricola.items.findIndex(
          x => x.key == this.newAreaItem.key
        );

        this.form.agricola.items[index] = _.cloneDeep(this.newAreaItem);
        // força atribuição no array p/ o vue detectar a alteração e deixar reativo
        this.form.agricola.items = this.form.agricola.items.slice();
      }
      this.getTotal();
      this.limparInput();
      this.focusDataTable();
      this.showAlertNotification({
        message: "Área incluída com sucesso.",
        type: "success"
      });

      this.enableArea = false;
      return;
    },
    aboveZero(value) {
      return value > 0 || "O valor deve ser maior do que 0.";
    },
    validateAreaPlantada() {
      if (
        this.newAreaItem.plantedArea > 0 &&
        this.areaPlantadaErrorMessages.length != 0
      ) {
        this.areaPlantadaErrorMessages = [];
      }
    },
    validateTiposSolo() {
      if (
        this.newAreaItem.soilType > 0 &&
        this.tiposSoloErrorMessages.length != 0
      ) {
        this.tiposSoloErrorMessages = [];
      }
    },
    validateInputBaseMoney() {
      if (
        !this.newAreaItem.plantedArea > 0 &&
        this.areaPlantadaErrorMessages.length == 0
      ) {
        this.areaPlantadaErrorMessages.push("Este campo é obrigatório");
      }

      if (
        !this.newAreaItem.soilType > 0 &&
        this.tiposSoloErrorMessages.length == 0
      ) {
        this.tiposSoloErrorMessages.push("Este campo é obrigatório");
      }
    },
    limparInput() {
      this.newAreaItem = _.cloneDeep(defaultItemAgricola);
      this.$refs.form.reset();
      this.areaPlantadaErrorMessages = [];
    },
    viewRow(item) {
      this.enableArea = true;
      this.readOnlyState = true;
      this.editState = false;
      this.newAreaItem = _.cloneDeep(item);
      this.isAddingRow = false;
      this.selectedRowToAffect = this.form.agricola.items.indexOf(item);
      this.focusForm();
    },
    editRow(item) {
      this.enableArea = true;
      this.readOnlyState = false;
      this.editState = true;
      this.newAreaItem = _.cloneDeep(item);
      this.isAddingRow = false;
      this.selectedRowToAffect = this.form.agricola.items.indexOf(item);
      this.focusForm();
    },
    closeModal(valor) {
      this.shouldDeleteData = valor;
      this.showDeleteModal = false;
      this.$emit("modal-closed");
    },
    deleteRow(item) {
      this.showDeleteModal = true;

      this.$once("modal-closed", () => {
        if (this.shouldDeleteData) {
          this.isAddingRow = false;
          this.selectedRowToAffect = null;
          this.form.agricola.items = this.form.agricola.items.filter(
            x => x !== item
          );
          this.getTotal();
        }
      });
    },
    duplicateRow(item) {
      this.newAreaItem = _.cloneDeep(item);
      this.newAreaItem.key = this.generateId();
      this.newAreaItem.coordenadas = [];
      this.newAreaItem.kmlFiles = [];
      this.form.agricola.items.push(_.cloneDeep(this.newAreaItem));
      this.editState = true;
      this.readOnlyState = false;
      this.isAddingRow = true;
      this.selectedRowToAffect = null;
      this.getTotal();
    },
    clear() {
      this.limparInput();
      this.enableArea = false;
      this.editState = false;
      this.readOnlyState = false;
      this.selectedRowToAffect = null;
    },
    affectRow(item) {
      let selectedRow = this.form.agricola.items.indexOf(item);
      let itemClass = "";

      if (this.isAddingRow) {
        itemClass = "table-row";
      }

      if (this.selectedRowToAffect === selectedRow) {
        itemClass += "selected-row";
      }

      return itemClass;
    },
    fetchClassificationSoil() {
      this.withLoading(this.requestListClassificacaoSolo(this.subProduct.id));
    },
    getTotal() {
      this.totalAreaSize = 0;
      if (this.form.agricola.items.length > 0) {
        for (let i = 0; i < this.form.agricola.items.length; i++) {
          this.totalAreaSize += this.form.agricola.items[i].plantedArea;
        }
      }
      return this.totalAreaSize;
    }
  },
  computed: {
    ...mapState("quotation", ["listClassificacaoSolo"]),
    getArrayTable() {
      let arrayItensAgricola = [];
      if (this.form.agricola.items.length > 0) {
        this.getTotal();
        arrayItensAgricola = [...this.form.agricola.items];
        arrayItensAgricola.push({
          nome: "ÁREA TOTAL (ha): ",
          plantedArea: this.totalAreaSize
        });
      }
      return arrayItensAgricola;
    },
    claimCurrentHarvestText() {
      return this.newAreaItem.claimCurrentHarvest ? "SIM" : "NÃO";
    },
    alreadyPlantedText() {
      return this.newAreaItem.alreadyPlanted ? "SIM" : "NÃO";
    },
    soyAfterSuggarCaneText() {
      return this.newAreaItem.soyAfterSuggarCane ? "SIM" : "NÃO";
    },
    getExpectedMinAreaSize() {
      return this.newAreaItem.plantedArea * 0.9; // Por requisito foi definido 10% de tolerancia na variação da area plantada total
    },
    getExpectedMaxAreaSize() {
      return this.newAreaItem.plantedArea * 1.1; // Por requisito foi definido 10% de tolerancia na variação da area plantada total
    },
    validForm() {
      return (
        this.$refs.form.validate() &&
        this.newAreaItem.nome.length > 0 &&
        this.newAreaItem.plantedArea > 0 &&
        this.newAreaItem.plantingDate != null &&
        this.newAreaItem.plantingTechniques != null &&
        this.newAreaItem.soilType != null &&
        this.newAreaItem.yearsPlanting != null
      );
    }
  }
};
</script>
